import { isCN } from './debug-mode';

/** Get the brand name based on IS_CN flag. Knox (overseas) | Ontox (China). */
export function getBrand(): string {
  return isCN() ? 'Ontox' : 'Knox';
}

/** React hook returning the brand name. Use in components for explicit brand display
 *  (logo alt, headings) where i18n `{{brand}}` interpolation doesn't apply. */
export function useBrand(): string {
  return getBrand();
}

/** Get the product logo URL based on IS_CN flag.
 *  Overseas: /knox-logo.png. China: /ontox-logo.svg.
 *  Both files live in service/frontend/public/. */
export function getLogoUrl(): string {
  return isCN() ? '/ontox-logo.svg' : '/knox-logo.png';
}

/** Get the daemon process name shown to users in install/manage commands
 *  (systemctl, journalctl, binary path, etc.). Knox: knoxd | Ontox: ontoxd.
 *  Must mirror backend knox-service/internal/pkg/i18n/brand.go GetDaemonName(). */
export function getDaemonName(): string {
  return isCN() ? 'ontoxd' : 'knoxd';
}

/** Get the daemon executable path shown in commands that invoke the binary. */
export function getDaemonExecutablePath(): string {
  return `/usr/local/bin/${getDaemonName()}`;
}

/** Get the default K8s namespace shown in kubectl commands. Knox: knox | Ontox: ontox.
 *  Must mirror backend knox-service/internal/pkg/i18n/brand.go GetDefaultNamespace(). */
export function getDefaultNamespace(): string {
  return isCN() ? 'ontox' : 'knox';
}

/** Get the built-in toolkit connector ID.
 *  Knox: knox-kit | Ontox: ontox-kit.
 *  Used to identify the always-present built-in management connector (cannot be
 *  disabled/deleted). Must mirror backend brand.go KnoxKitConnectorID(). */
export function getKnoxKitConnectorId(): string {
  return isCN() ? 'ontox-kit' : 'knox-kit';
}

/** React hook returning the product logo URL. Use wherever a product logo is rendered. */
export function useLogoUrl(): string {
  return getLogoUrl();
}
